import { render, staticRenderFns } from "./EditarMarca.vue?vue&type=template&id=16171dc3&"
import script from "./EditarMarca.vue?vue&type=script&lang=js&"
export * from "./EditarMarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports